// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accountUserInitials{display:none}@media(max-width: 780px){.accountUserInitials{display:inline}.accountUserName{display:none}}`, "",{"version":3,"sources":["webpack://./src/components/pages/Account/account.css"],"names":[],"mappings":"AAAA,qBACE,YAAA,CAGF,yBACE,qBACE,cAAA,CAEF,iBACE,YAAA,CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
